if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        if (this.prevButton) this.prevButton.addEventListener('click', this.prev.bind(this));
        if (this.nextButton) this.nextButton.addEventListener('click', this.next.bind(this));
        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowRight') this.next();
          if (event.code === 'ArrowLeft') this.prev();
        });
        // Capture phase so this runs before ModalDialog's bubble-phase "click closes modal" handler.
        this.pointerDownPosition = null;
        this.addEventListener(
          'pointerdown',
          (event) => {
            this.pointerDownPosition = { x: event.clientX, y: event.clientY };
          },
          true
        );
        this.addEventListener(
          'pointerup',
          (event) => {
            if (!this.prevButton) return;
            if (event.target.closest('.product-media-modal__toggle, .product-media-modal__nav, deferred-media, product-model'))
              return;
            const start = this.pointerDownPosition;
            const movedTooFar =
              start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10;
            if (movedTooFar) return;
            event.stopPropagation();
            if (event.clientX < window.innerWidth / 2) {
              this.prev();
            } else {
              this.next();
            }
          },
          true
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener.getAttribute('data-media-id'));
      }

      next() {
        this.showActiveMedia(this.getMediaId(1));
      }

      prev() {
        this.showActiveMedia(this.getMediaId(-1));
      }

      getMediaId(offset) {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentIndex = mediaItems.findIndex((element) => element.classList.contains('active'));
        const newIndex = (currentIndex + offset + mediaItems.length) % mediaItems.length;
        return mediaItems[newIndex].dataset.mediaId;
      }

      showActiveMedia(mediaId) {
        window.pauseAllMedia();
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
